import { CheckCircleFilled } from "@ant-design/icons";
import { Form, Typography } from "antd";
import { useOptionsBanks } from "hook/finance/withdraw/useWithdraw";
import React from "react";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const CardBank = ({ data, index }) => {
  // -------------------------- VAR -----------------------------
  const { data: options } = useOptionsBanks();
  const form = Form?.useFormInstance();
  const code = Form?.useWatch("code", form) || null;
  const shortName = data?.shortName || "";
  const name = data?.name;
  const codeS = data?.code;
  const logo = data?.logo;
  const chosen = code === codeS ? true : false;
  const size = 30;

  const isLast = index === options?.length - 1;
  const border = isLast
    ? {}
    : {
        borderBottom: "1px solid #e5e5e5",
      };
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleSelect = () => {
    form?.setFieldValue("code", codeS);
    form?.setFieldValue("openBank", false);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLogo = () => {
    if (chosen)
      return <CheckCircleFilled style={{ color: "green", fontSize: size }} />;
    return (
      <img
        src={logo}
        style={{ width: 80, height: "auto", borderRadius: "50%" }}
        alt="logo-bank"
      />
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <div
      onClick={handleSelect}
      style={{
        display: "flex",
        gap: 10,
        cursor: "pointer",
        ...border,
        alignItems: "center",
        paddingBottom: 10,
      }}
    >
      <div style={{ display: "flex", justifyContent: "center", flex: 0.15 }}>
        <div>{renderLogo()}</div>
      </div>
      <div
        style={{ display: "flex", flex: 0.8, flexDirection: "column", gap: 8 }}
      >
        <div style={{ fontSize: 16, fontWeight: 500 }}>{shortName}</div>
        <Typography.Text type="secondary">{name}</Typography.Text>
      </div>
    </div>
  );
};
export default CardBank;
